var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    fill: "none",
    viewBox: "0 0 21 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 1H6v5h1zm8 0h-1v5h1zM0 3h5v1.5H1.5V10h18V4.5H16V3h5v19H0zm8 1.5V3h5v1.5zm-6.5 16V11h18v9.5z",
    clipRule: "evenodd"
  })));
};
export { SvgCalendar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcgMUg2djVoMVYxem04IDBoLTF2NWgxVjF6TTAgM2g1djEuNUgxLjVWMTBoMThWNC41SDE2VjNoNXYxOUgwVjN6bTggMS41VjNoNXYxLjVIOHptLTYuNSAxNlYxMWgxOHY5LjVoLTE4eiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";